// Product gallery: thumbnails scroll the snap track to a slide; scrolling the track updates the current thumbnail.
class ProductGallery extends HTMLElement {
  #abort;
  #raf = 0;

  connectedCallback() {
    this.#abort = new AbortController();
    const { signal } = this.#abort;

    this.addEventListener(
      'command',
      (event) => {
        if (event.command !== '--go') return;
        const index = Number(event.source?.dataset.index || 0);
        this.#go(index);
      },
      { signal },
    );

    const track = this.querySelector('[data-gallery-track]');
    if (!track) return;
    track.addEventListener(
      'scroll',
      () => {
        cancelAnimationFrame(this.#raf);
        this.#raf = requestAnimationFrame(() => {
          const width = track.clientWidth || 1;
          this.#sync(Math.round(Math.abs(track.scrollLeft) / width));
        });
      },
      { signal, passive: true },
    );
  }

  disconnectedCallback() {
    this.#abort?.abort();
    cancelAnimationFrame(this.#raf);
  }

  #go(index) {
    const track = this.querySelector('[data-gallery-track]');
    const slide = track?.children[index];
    if (!slide) return;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    slide.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'nearest', inline: 'start' });
    this.#sync(index);
  }

  #sync(index) {
    this.querySelectorAll('[data-gallery-thumb]').forEach((thumb, i) => {
      thumb.setAttribute('aria-current', i === index ? 'true' : 'false');
    });
  }
}

if (!customElements.get('s-product-gallery')) customElements.define('s-product-gallery', ProductGallery);
